<script lang="ts">
  import type { Snippet } from 'svelte';

  let {
    title,
    open = $bindable(true),
    children,
    aside,
  }: { title: string; open?: boolean; children: Snippet; aside?: Snippet } = $props();
</script>

<section class:open>
  <header>
    <button class="toggle" onclick={() => (open = !open)} aria-expanded={open}>
      <span class="chev" aria-hidden="true">{open ? '▾' : '▸'}</span>
      {title}
    </button>
    {#if aside}<div class="aside">{@render aside()}</div>{/if}
  </header>
  {#if open}
    <div class="body">{@render children()}</div>
  {/if}
</section>

<style>
  section {
    border-bottom: 1px solid var(--line);
  }
  header {
    display: flex;
    align-items: center;
    padding: 0 12px;
  }
  .toggle {
    flex: 1;
    text-align: left;
    background: none;
    border: 0;
    padding: 10px 0;
    font-weight: 600;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    font-size: 12px;
    color: var(--muted);
  }
  section.open .toggle {
    color: var(--text);
  }
  .chev {
    display: inline-block;
    width: 14px;
  }
  .body {
    padding: 2px 14px 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
</style>
